import React from 'react';
import { PaymentForm } from '../components/PaymentForm';
export function PaymentRequests() {
  return <div data-id="element-9742">
      <PaymentForm data-id="element-9743" />
    </div>;
}